<i *ngIf="text" class="pi pi-info-circle text-color-secondary platform-health-help-icon"
    [pTooltip]="text" [tooltipPosition]="tooltipPosition" tooltipStyleClass="platform-health-help-tooltip"
    [attr.aria-label]="text" role="img"></i>
